import { useContext } from "react";
import { PresentationParamsContext } from "sanity/_singletons";
/** @public */
function usePresentationParams(t0) {
	let throwOnMissingContext = t0 === void 0 || t0, params = useContext(PresentationParamsContext);
	if (throwOnMissingContext && !params) throw Error("Presentation params context is missing");
	return params;
}
export { usePresentationParams as t };

//# sourceMappingURL=usePresentationParams-B_1iItpx.js.map